export const state = {
  allTasksCount: 0,
  expiredTasksCount: 0,
  needToUpdate: false
}

export const mutations = {
  SET_DASHBOARD_PROP (state, [field, value]) {
    state[field] = value
  }
}

export default {
  state,
  mutations
}
